import { Rule } from 'rc-field-form/es/interface';
import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { commonTexts } from 'consts/text';
import { emailRegExp } from 'consts/regexps';
import { createFieldValidationRules, createPatternRule } from 'utils/formValidationHelpers';

type EmailInputElementProps = Pick<AppFormItemProps, 'name'> & {
    disabled?: boolean;
    extraOnDisabled?: string;
    withEmailValidatingRules?: boolean;
};

export const EmailInputElement = ({
    disabled = false,
    extraOnDisabled,
    withEmailValidatingRules = true,
    name = formFields.email,
}: EmailInputElementProps) => {
    const validationRules: Rule[] = createFieldValidationRules('email', {
        required: true,
        email: withEmailValidatingRules,
    });

    if (withEmailValidatingRules) {
        validationRules.push(
            createPatternRule(emailRegExp, commonTexts.errorMessages.emailIllegalCharacters),
        );
    }

    return (
        <AppFormItem
            disabled={disabled}
            label={commonTexts.inputLabels.email}
            name={name}
            rules={validationRules}
            extra={disabled && extraOnDisabled}
            accessibilityLabel="Pole email"
        >
            <AppInput
                autoComplete="email"
                disabled={disabled}
                accessibilityLabel="Pole email"
                placeholder="Podaj email"
            />
        </AppFormItem>
    );
};
